import { Box } from '@chakra-ui/react';
import type { ComponentProps, ReactElement } from 'react';

export function Steps({
  children,
  ...props
}: ComponentProps<'div'>): ReactElement {
  return (
    // @ts-expect-error - algolia is overriding the JSX namespace
    <Box
      ml={4}
      mb={12}
      borderLeftWidth={1}
      pl={6}
      sx={{
        counterReset: 'step',
        '& h3': {
          counterIncrement: 'step'
        },
        '& h3::before': {
          position: 'absolute',
          width: '33px',
          height: '33px',
          backgroundColor: 'var(--borderColor)',
          borderWidth: '4px',
          fontSize: '1rem',
          lineHeight: '1.5rem',
          fontWeight: '400',
          textAlign: 'center',
          borderRadius: '9999px',
          color: 'gray.400',
          textIndent: '-1px',
          marginLeft: '-41px',
          marginTop: '3px',
          borderColor: 'var(--bodyBg)',
          content: 'counter(step)'
        }
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
